// extracted by mini-css-extract-plugin
export var accent = "_bo-4";
export var add = "_bo-j";
export var addIcon = "_bo-k";
export var deleteIcon = "_bo-i";
export var disabled = "_bo-9";
export var ellipsis = "_bo-f";
export var error = "_bo-3";
export var form = "_bo-5";
export var hideFocus = "_bo-2";
export var icon = "_bo-7";
export var input = "_bo-e";
export var listItem = "_bo-h";
export var mediumHeight = "_bo-b";
export var noBorder = "_bo-8";
export var noRadius = "_bo-1";
export var shortHeight = "_bo-a";
export var tallHeight = "_bo-c";
export var textInput = "_bo-0";
export var vertical = "_bo-g";
export var veryTallHeight = "_bo-d";
export var widget = "_bo-6";